<template>
  <a
     class="link"
     :href="lmsUrl"
     target="_blank"
     @mouseover="isHover=true"
     @mouseout="isHover=false"
  >
    <span class="link-inner-wrapper">
      <GIcon
        :name="icon"
        :stroke="iconColor"
        size="14px"
        class="gobito-icon icon"
      />
      <span :class="icon" />
      <span class="link-inner-text">
        <slot />
      </span>
    </span>
  </a>
</template>

<script>
import GIcon from '@trendyol-js/grace/core/GIcon';
import SupplierService from '@/services/SupplierService';

export default {
  name: 'GobitoLink',

  components: {
    GIcon,
  },

  props: {
    icon: {
      type: String,
      default: 'play-circle',
    },

    href: {
      type: String,
      required: true,
    },

    lmsHref: {
      type: String,
      required: true,
    },

    newLmsUrl: {
      type: String,
      required: true,
    },
  },

  data () {
    return {
      isHover: false,
    };
  },
  computed: {
    lmsUrl () {
      if ((SupplierService.isMeal() || SupplierService.isMarket()) && this.newLmsUrl) {
        return `/account/sso/lms?domain=TYGO&url=${this.newLmsUrl}`;
      } else {
        return `/account/sso/lms?url=${this.lmsHref}`;
      }
    },
    iconColor () {
      if (this.isHover) {
        return '#ffffff';
      }
      return '#8a50ff';
    },
  },
};
</script>

<style scoped lang="scss">
.link{
  line-height: 1;
  display: inline-block;
  border: 1px solid transparent;
  padding: 0;
  border-radius: 4px;
  background-image: linear-gradient(to bottom, #f0f2f6, #f0f2f6), linear-gradient(100deg, #8c4eff, #5794ff);
  background-origin: border-box;
  background-clip: content-box, border-box;
  text-decoration: none !important;
  cursor: pointer;

  .icon {
    margin-right: 5px;
  }

  .link-inner-wrapper{
    display: block;
    padding: 10px 20px;
  }
  .link-inner-text{
    background-image: linear-gradient(96deg, #8c4eff, #5794ff);
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &.transparent{
    margin-left: 10px;
    background-image: none;
    .icon {
      margin-right: 0;
      &:before{
        color: #ffffff;
      }
    }
    .link-inner-wrapper{
      position: relative;
      padding: 0;
      padding-left: 10px;
      text-decoration: underline;
      color: #8a50ff;

      &:before{
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 1px;
        background-color: #e6e6e6;
      }
    }

    &:hover{
      background-image: none;
      .icon:before{
        color: #ffffff;
      }
      .link-inner-text{
        background-image: linear-gradient(96deg, #8c4eff, #5794ff);
        -webkit-text-fill-color: transparent;
      }
    }
  }

  &.white{
    background-image: linear-gradient(to bottom, #fff, #fff), linear-gradient(100deg, #8c4eff, #5794ff);
  }

  &:hover{
    text-decoration: none;
    background-image: linear-gradient(280deg, #5794ff, #8c4eff);

    .link-inner-text{
      background-image: none;
      color: #ffffff;
      -webkit-text-fill-color: #ffffff;
    }
  }
}
</style>
